import NewsDetail from '../../views/news/NewsDetail.vue';
import NewsSwiper from '../../views/news/NewsSwiper.vue';

// news詳細本文表示コンポーネント
window.Vue.component('news-detail', NewsDetail);
window.Vue.component('news-swiper', NewsSwiper);
